<template lang="pug">
section
  div
    | The online form must be submitted
    | by the sponsor ONLY,
    | e.g. if you have a representative
    | they can’t submit the form on your behalf.

  br

  div
    | You will process a payment
    | to complete the submission process
    | -
    | see ‘Pay a fee’ section
    | for more information.

  br

  div
    | Once you have submitted
    | your online application, then a
    |
    b submission sheet
    |
    | is generated and you must save it
    | (as a pdf file) and your
    |
    b authorising officer must date and sign it
    |
    | (either digitally or as a wet signature).
    | Attach this signed
    | and dated submission form
    | to the email with all other supporting documents
    | you will send to the Home Office
    | -
    | see ‘Sending documents’ section
    | for more information.
</template>

<script>
export default {
  name: "submit_oa_form",
};
</script>